import DynamicComponentError from "%/dynamic-component-editor/errors/dynamic-component-error";
import SharedBaseOption from "%/dynamic-component-editor/classes/shared-base-option";

export default class BaseRootOption extends SharedBaseOption {
  value = null;

  constructor(value = null, hideFromInspector = false, useInspectorLabel = true) {
    super(hideFromInspector, useInspectorLabel);

    this.value = this.constructor.defaultValue;

    if (value) {
      this.value = value;
    }
  }

  // duplicate of getValueFromConfiguration because of the way the code is structured,
  // because root options do not have states, but the functions are used for both base root options
  // and base options
  getValueOrDefault(options = {}) {
    const value = options[this.optionKey] ?? this.value;

    if (value === undefined) {
      throw new DynamicComponentError("Option value is undefined", {
        "options": options,
        "optionName": this.constructor.name,
        "optionKey": this.optionKey,
      });
    }

    return {
      [this.optionKey]: this.constructor.getModifiedRawValue(value, options, "default"),
    };
  }

  getValueFromConfiguration(configurationOptionValues) {
    const defaultValue = this.value;
    let key = this.optionKey;

    let optionValue = configurationOptionValues[key];

    if (optionValue === undefined) {
      optionValue = defaultValue;
    }

    return this.constructor?.getValue(optionValue);
  }
}
